import backgroundsMain from '@/store/modules/backgrounds/main/backgroundsMain'
import { STORE_NAME_BACKGROUNDS_MAIN } from '@/store/store.list'

export default {
  namespaced: true,
  modules: {
    [STORE_NAME_BACKGROUNDS_MAIN]: backgroundsMain
  }
}
